import { render, staticRenderFns } from "./ProspectsSales.vue?vue&type=template&id=193064b6&"
import script from "./ProspectsSales.vue?vue&type=script&lang=js&"
export * from "./ProspectsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports